<div class="spinner-img">
  <img src="assets/img/logo.png" class="logo">
</div>
<div class="loader"></div>
<div class="spinner-text">
  <label>Espere un momento por favor...</label>
</div>
